"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("./core");
if (typeof Intl.PluralRules === 'undefined') {
    Object.defineProperty(Intl, 'PluralRules', {
        value: core_1.PluralRules,
        writable: true,
        enumerable: false,
        configurable: true,
    });
}



/*****************
 ** WEBPACK FOOTER
 ** ../~/@formatjs/intl-pluralrules/dist/polyfill.js
 ** module id = 1546
 ** module chunks = 0
 **/